const Iframe = {
  el: {
    iframe: document.getElementById('ResponsiveIframe')
  },

  init: () => {
    if(Iframe.el.iframe) {
      Iframe.getSize();
    }
  },

  getSize: () => {
    var the_height = Iframe.el.iframe.contentWindow.document.body.scrollHeight;
    Iframe.el.iframe.height = the_height;
  },
};

export default Iframe;
